// extracted by mini-css-extract-plugin
export var Digital = "project-module--Digital--099b2";
export var Fuel = "project-module--Fuel--b9428";
export var Money = "project-module--Money--0f4c8";
export var Time = "project-module--Time--4a6c4";
export var Trees = "project-module--Trees--0a8b8";
export var active = "project-module--active--1676f";
export var additionalInformation = "project-module--additionalInformation--15333";
export var benefitContainer = "project-module--benefitContainer--6ac70";
export var benefits = "project-module--benefits--5f48e";
export var content = "project-module--content--7fc57";
export var contentContainer = "project-module--contentContainer--b42c5";
export var contentSection = "project-module--contentSection--9376a";
export var contributePartner = "project-module--contributePartner--42bed";
export var contributerLink = "project-module--contributerLink--94d95";
export var contributingPartners = "project-module--contributingPartners--873e2";
export var countries = "project-module--countries--89797";
export var countryLink = "project-module--countryLink--ba93a";
export var countryList = "project-module--countryList--12985";
export var description = "project-module--description--297d3";
export var disclaimer = "project-module--disclaimer--6f754";
export var hero = "project-module--hero--f1f85";
export var imageContainer = "project-module--imageContainer--cc248";
export var informationList = "project-module--informationList--04070";
export var label = "project-module--label--4b0a3";
export var leaderLink = "project-module--leaderLink--52fed";
export var listItem = "project-module--listItem--ca7aa";
export var mediaContainer = "project-module--mediaContainer--8a115";
export var modal = "project-module--modal--6610a";
export var partnerContainer = "project-module--partnerContainer--e5855";
export var starBackground = "project-module--starBackground--babf0";
export var timelineContainer = "project-module--timelineContainer--f3890";
export var timelineInfo = "project-module--timelineInfo--02f0c";